<template>
  <div id="appHeader">
    <el-row class="appHeader">
      <el-col :span="12">
        <img class="logo-pic" src="../../assets/img/logowl.png" alt="" />
        <!-- <img class="logo-pic" src="../../assets/img/logowl.png" alt=""> -->
        <!-- <el-breadcrumb separator="/">
                    <el-breadcrumb-item>
                        {{currenRoute.firstName?currenRoute.firstName:'首页'}}
                    </el-breadcrumb-item>
                    <template>
                        <el-breadcrumb-item v-if="currenRoute.secPath" class="shou">{{currenRoute.secName}}</el-breadcrumb-item>
                        <el-breadcrumb-item v-if="currenRoute.third" class="shou">{{currenRoute.third}}</el-breadcrumb-item>
                    </template>
                </el-breadcrumb> -->
      </el-col>
      <el-col :span="12" class="right-info">
        <!-- <el-dropdown trigger="click">
                    <el-badge :max="99" :value="msgNum" class="item">
                        <span class="title">
                            <icon-svg icon-class="remind"></icon-svg>
                        </span>
                    </el-badge>
                    <el-dropdown-menu slot="dropdown" v-if="msgArr.length>0">
                        <el-dropdown-item :key="index" v-for="(item,index) in msgArr" @click.native="readMsg(item)" v-if="index<6">
                            {{ item.sendMsgTask.title }}
                        </el-dropdown-item>
                    </el-dropdown-menu>
                    <el-dropdown-menu slot="dropdown" v-if="msgArr.length===0">
                        <el-dropdown-item>
                            暂无新消息
                        </el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown> -->
        <div class="header-userInfo">
          <span
            style="cursor: pointer; margin-right: 20px"
            @click="goFirst"
            v-if="power('TALLY')"
          >
            <img
              style="
                display: inline-block;
                width: 40px;
                vertical-align: middle;
                margin-right: -8px;
                margin-top: -4px;
              "
              src="../../assets/img/notice.png"
              alt=""
            />
            {{ NOTICE_NUM }}
          </span>
          <span
            >{{
              $store.state.user.currentUser.dept &&
              $store.state.user.currentUser.org.name
            }}&ensp;</span
          >
          <span
            >{{
              $store.state.user.currentUser.dept &&
              $store.state.user.currentUser.dept.name
            }}&ensp;</span
          >
        </div>
        <el-dropdown trigger="click" class="userCss">
          <span class="title">
            <img src="../../assets/img/i-user.png" alt="" />
            {{ $store.state.user.currentUser.name
            }}<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item @click.native="changePwd"
              >修改密码</el-dropdown-item
            >
            <el-dropdown-item @click.native="logout">注销</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-col>
    <el-dialog
        title="修改密码"
        :modal="true"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        :show-close="false"
        :visible.sync="showChange"
        width="500px"
        :before-close="cancel"
      >
        <el-form
          :model="password"
          label-width="100px"
          ref="ruleForm"
          :rules="rules"
        >
          <div class="changePwdScrb" v-if="showWarningTxt">
            <p>由于安全的需求，检测到您的密码不符合规范。请修改密码。</p>
          </div>
          <el-form-item label="原密码:" prop="oldPwd">
            <el-input
              v-model="password.oldPwd"
              placeholder=""
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码:" prop="newPwd">
            <el-input
              v-model="password.newPwd"
              placeholder=""
              type="password"
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码:" prop="confirmNewPwd">
            <el-input
              v-model="password.confirmNewPwd"
              placeholder=""
              type="password"
            ></el-input>
          </el-form-item>
        </el-form>
        <div class="changePwdScrb">
          <p>密码由大小写字母、数字、特殊字符组成，长度至少8位，不超过32位</p>
        </div>
        <div class="pwdFoot">
          <el-button type="primary" @click.native="submitPwd">确定</el-button>
          <el-button
            v-if="!showWarningTxt"
            type="primary"
            @click.native="cancel"
            >取消</el-button
          >
        </div>
      </el-dialog>
    </el-row>
    <el-row>
      <el-col :span="24">
        <!-- <div class="tags-view-container"  :style="{'margin-left':menuIsCollapse?'64px':'200px'}"> -->
        <div
          class="tags-view-container"
          :class="{ 'tags-l': menuIsCollapse, 'tags-r': !menuIsCollapse }"
        >
          <!-- <div class="history"> -->
          <!-- <el-scrollbar> -->
          <scroll-pane class="tags-view-wrapper" ref="scrollPane">
            <router-link
              ref="tag"
              class="tags-view-item"
              :class="isActive(tag) ? 'active' : ''"
              v-for="tag in Array.from(cachedViews)"
              :to="tag.path"
              :key="tag.path"
              @contextmenu.prevent.native="openMenu(tag, $event)"
            >
              {{ tag.name }}
              <span
                class="el-icon-close"
                @click.prevent.stop="closeSelectedTag(tag)"
              ></span>
            </router-link>
          </scroll-pane>
          <!-- </el-scrollbar> -->
          <ul
            class="contextmenu"
            v-show="visible"
            :style="{ left: left + 'px', top: top + 'px' }"
          >
            <li @click="closeSelectedTag(selectedTag)">{{ "关闭当前页" }}</li>
            <li @click="closeOthersTags">{{ "关闭其他页面" }}</li>
            <li @click="closeAllTags">{{ "关闭所有" }}</li>
          </ul>
          <!-- </div> -->
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { out, updataPwd } from "@/api/auth/auth";
import ScrollPane from "@/components/ScrollPane";
export default {
  name: "appHeader",
  components: {
    ScrollPane,
  },
  data() {
    var validPassword = (rule, value, callback) => {
      // let reg =/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[$@$!%*?&])[A-Za-z\d$@$!%*?&]{8,}/; //原来的
      // let reg =
      // /^(?=.*?[A-Z])(?=.*?[a-z])(?=.*?[0-9])(?=.*?[!@#$%^&*-+]).{10,}$/;  //果园的
      
      //by talk  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[@$!%*#?&])[A-Za-z\d@$!%*#?&]{8,}$/;
      // let reg =
      // /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[-_!@#$%^&*])[a-zA-Z0-9-_!@#$%^&*]{8,}$/;
	  
	  //外理最新要求
	  let reg =
	  /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[a-zA-Z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,32}$/;
  
      if (!reg.test(value)) {
        callback(
          new Error(
            "密码由大小写字母、数字、特殊字符组成，长度至少8位，不超过32位"
          )
        );
      } else {
        callback();
      }
    };
    var validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请再次输入密码"));
      } else if (value !== this.password.newPwd) {
        callback(new Error("两次输入密码不一致!"));
      } else {
        callback();
      }
    };
    return {
      currentUser: this.$store.state.user.currentUser,
      password: {
        oldPwd: "", //原始密码
        newPwd: "", //新密码
        confirmNewPwd: "", //确认密码
      },
      showChange: false,
      showWarningTxt: false,
      currenRoute: {
        firstName: "",
        secName: "",
        secPath: "",
        third: "",
        thirdPath: "",
      },
      visible: false,
      top: 0,
      left: 0,
      NOTICE_NUM: 0,
      rules: {
        oldPwd: [{ required: true, message: "请输入原密码", trigger: "blur" }],
        newPwd: [
          { required: true, message: "请输入新密码", trigger: "blur" },
          { validator: validPassword, trigger: "blur" },
        ],
        confirmNewPwd: [
          { required: true, message: "请确认密码", trigger: "blur" },
          { validator: validatePass2, trigger: "blur" },
        ],
      },
      loginForm: {
        userName: "",
        password: "",
      },
    };
  },
  mounted() {
    this.NOTICE_NUM = localStorage.getItem("NOTICE_NUM");
    this.filterBread(this.$route);
    this.addViewTags();
    this.checkLoginInfor();
  },
  computed: {
    cachedViews() {
      return this.$store.state.tagsView.cachedViews;
    },
    menuIsCollapse() {
      return this.$store.getters.menuIsCollapse;
    },
  },
  watch: {
    $route(newVal) {
      this.currenRoute = {
        firstName: "",
        secName: "",
        secPath: "",
        third: "",
        thirdPath: "",
      };
      if (newVal) {
        this.filterBread(newVal);
      }
      this.addViewTags();
      this.moveToCurrentTag();
    },
    visible(value) {
      if (value) {
        document.body.addEventListener("click", this.closeMenu);
      } else {
        document.body.removeEventListener("click", this.closeMenu);
      }
    },
  },
  methods: {
    checkLoginInfor() {
      this.loginForm = JSON.parse(localStorage.getItem("loginInfor"));
      console.log("checkLoginInfor loginForm", this.loginForm);
      //let password = loginForm.password;
      //至少8-16个字符，至少1个大写字母，1个小写字母和1个数字，其他可以是任意字符
      //let reg =  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{8,16}$/

      //至少8个字符，至少1个大写字母，1个小写字母，1个数字和1个特殊字符
      let reg =
       /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~])[a-zA-Z\d!"#$%&'()*+,-./:;<=>?@[\]^_`{|}~]{8,32}$/;;
      // let test = "Lzz200088@";
      let res = reg.test(this.loginForm.password);
      console.log("checkLoginInfor res", res);

      if (res) {
        return;
      } else {
        this.showChange = true;
        this.showWarningTxt = true;
      }
    },
    generateRoute() {
      if (this.$route.name) {
        return this.$route;
      }
      return false;
    },
    addViewTags() {
      const route = this.generateRoute();
      if (!route) {
        return false;
      }
      this.$store.dispatch("addVisitedViews", route);
    },
    filterBread(newVal) {
      let a = newVal.fullPath.split("/");
      if (newVal.path.indexOf("Home") !== -1) {
        this.currenRoute.firstName = "平台管理";
        if (newVal.path.indexOf("SystemS") !== -1) {
          this.currenRoute.secName = "系统管理工作台";
          this.currenRoute.secPath = "/Home/SystemS";
        } else if (newVal.path.indexOf("SystemBase") !== -1) {
          this.currenRoute.secName = "基础管理工作台";
          this.currenRoute.secPath = "/Home/SystemBase";
        }
      } else if (newVal.path.indexOf("business") !== -1) {
        this.currenRoute.firstName = "商务管理";
        this.currenRoute.secName = "商务管理工作台";
        this.currenRoute.secPath = "/business/busPla";
      } else if (newVal.path.indexOf("work") !== -1) {
        this.currenRoute.firstName = "现场作业管理";
        if (newVal.path.indexOf("gatePanel") !== -1) {
          this.currenRoute.secName = "铁路道闸工作台";
          this.currenRoute.secPath = "/work/gatePanel";
        } else if (newVal.path.indexOf("JobPlan") !== -1) {
          this.currenRoute.secName = "铁路作业计划管理";
          this.currenRoute.secPath = "/work/JobPlan";
        } else if (newVal.path.indexOf("containerJob") !== -1) {
          this.currenRoute.secName = "铁路集装箱作业台";
          this.currenRoute.secPath = "/work/containerJob";
        } else if (newVal.path.indexOf("yardPlan") !== -1) {
          this.currenRoute.secName = "堆场策划管理";
          this.currenRoute.secPath = "/work/yardPlan";
        }
      }
      if (a.length >= 4) {
        this.currenRoute.third = newVal.name;
        this.currenRoute.thirdPath = newVal.fullPath;
      }
      // console.log(55,this.currenRoute)
    },
    logout() {
      out().then((res) => {
        this.$router.replace({
          path: "/Login",
        }); // 跳转路由
        localStorage.clear();
        location.reload();
      });
    },
    goFirst() {
      this.$router.replace({
        path: "/first",
      });
    },
    changePwd() {
      this.showChange = true;
    },
    submitPwd() {
      console.log("");
      let _this = this;
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          console.log("验证通过");
          updataPwd(this.password).then((res) => {
            if (res) {
              _this.loginForm.password = _this.password.newPwd;
              console.log("修改时保存的 用户", _this.loginForm);
              localStorage.setItem(
                "loginInfor",
                JSON.stringify(_this.loginForm)
              );
              let test = JSON.parse(localStorage.getItem("loginInfor"));
              console.log("test", test);
              _this.showChange = false;
              _this.showWarningTxt = false;
              _this.$message({
                message: "修改密码成功,请重新登陆",
                type: "success",
              });
              //location.reload()
              _this.cancel();

              setTimeout(function () {
                _this.logout()
              }, 1000);

            }
          });
        } else {
          console.log("验证不过");
        }
      });
      return;
      if (this.password.newPwd === this.password.confirmNewPwd) {
      } else {
        this.$message({
          message: "两次输入密码不一致",
          type: "warning",
        });
      }
    },
    cancel() {
      this.password = {};
      this.showChange = false;
    },
    // 卡片
    isActive(route) {
      return route.path === this.$route.path;
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag;
      this.$nextTick(() => {
        for (const tag of tags) {
          if (tag.to === this.$route.path) {
            this.$refs.scrollPane.moveToTarget(tag.$el);
            break;
          }
        }
      });
    },
    closeSelectedTag(view) {
      this.$store.dispatch("delVisitedViews", view).then((views) => {
        if (this.isActive(view)) {
          const latestView = views.slice(-1)[0];
          if (latestView) {
            this.$router.push(latestView.path);
          } else {
            this.$router.push("/");
          }
        }
      });
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag.path);
      this.$store.dispatch("delOthersViews", this.selectedTag).then(() => {
        this.moveToCurrentTag();
      });
    },
    closeAllTags() {
      this.$store.dispatch("delAllViews");
      this.$router.push("/first");
    },
    openMenu(tag, e) {
      this.visible = true;
      this.selectedTag = tag;
      this.left = e.clientX;
      this.top = e.clientY - 58;
    },
    closeSelectedTag(view) {
      this.$store.dispatch("delVisitedViews", view).then((views) => {
        if (this.isActive(view)) {
          const latestView = views.slice(-1)[0];
          if (latestView) {
            this.$router.push(latestView.path);
          } else {
            this.$router.push("/first");
          }
        }
      });
    },
    closeMenu() {
      this.visible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.changePwdScrb {
  float: left;
  clear: both;
  display: block;
  width: 100%;
  background: #fdfbda;
  color: #333;
  font-size: 12px;
  padding: 10px 10px 10px 10px;
  margin: 0 0 30px 0;
}

#appHeader {
  position: fixed;
  top: 0;
  right: 0;
  // width: calc(100% - 200px);
  width: 100%;
  z-index: 199;
}
.appHeader {
  width: 100%;
  height: 60px;
  line-height: 20px;
  box-shadow: 0 1px 5px 0 rgba(0, 34, 77, 0.08);
  margin: 0px;
  // padding: 18px 15px;
  background-image: linear-gradient(to right, #696aee, #5872ec);
  color: #ffffff;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.systemName {
  font-size: 28px;
  line-height: 28px;
  color: #fff;
}

.userCss {
  color: #fff;
}

.right-info {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  .el-dropdown {
    margin: 0px 15px;
    cursor: pointer;
    color: #fff;
    .title {
      font-size: 16px;
      line-height: 16px;
      img {
        vertical-align: bottom;
        padding: 0 6px;
      }
    }
  }
}

.pwdFoot {
  margin: 0 auto;
  text-align: right;
} // .history {
//     width: 100%;
//     background: #fff;
//     white-space: nowrap;
//     height: 34px;
//     border-bottom: 1px solid #d8dce5;
// }
.tags-view-container {
  float: right;
  .tags-view-wrapper {
    background: #fff;
    height: 34px;
    border-bottom: 1px solid #d8dce5;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.12), 0 0 3px 0 rgba(0, 0, 0, 0.04);
    // overflow-x: auto;
    .tags-view-item {
      display: inline-block;
      position: relative;
      height: 26px;
      line-height: 26px;
      border: 1px solid #d8dce5;
      color: #495060;
      background: #fff;
      padding: 0 8px;
      font-size: 12px;
      margin-left: 5px;
      margin-top: 4px;
      &:first-of-type {
        margin-left: 15px;
      }
      &.active {
        background-color: #409eff;
        color: #fff;
        border-color: #409eff;
        &::before {
          content: "";
          background: #fff;
          display: inline-block;
          width: 8px;
          height: 8px;
          border-radius: 50%;
          position: relative;
          margin-right: 2px;
        }
      }
    }
  }
  .contextmenu {
    margin: 0;
    background: #fff;
    z-index: 100;
    position: absolute;
    list-style-type: none;
    padding: 5px 0;
    border-radius: 4px;
    font-size: 12px;
    font-weight: 400;
    color: #333;
    box-shadow: 2px 2px 3px 0 rgba(0, 0, 0, 0.3);
    li {
      margin: 0;
      padding: 7px 16px;
      cursor: pointer;
      &:hover {
        background: #eee;
      }
    }
  }
}

// .tags-view-wrapper::-webkit-scrollbar {
//     display: none;
// }

.tags-l {
  width: calc(100% - 64px);
}
.tags-r {
  width: calc(100% - 200px);
}
.tags-view-item {
  display: inline-block;
  position: relative;
  height: 26px;
  line-height: 26px;
  border: 1px solid #d8dce5;
  color: #495060;
  background: #fff;
  padding: 0 8px;
  font-size: 12px;
  margin-left: 5px;
  margin-top: 4px;
  text-decoration: none;
}
.shou {
  cursor: pointer;
}
.header-userInfo {
  border-right: 1px solid #999;
  box-shadow: 2px 0px 0px #ccc;
  font-size: 16px;
  padding-right: 10px;
}

.logo-pic {
  height: 40px;
  padding-left: 210px;
}
</style>



// WEBPACK FOOTER //
// src/views/layout/appHeader.vue